import * as React from "react"
import Box from "@mui/material/Box"
import UiModal from "@mui/material/Modal"
import styled from "styled-components"

export default function Modal({ children, fullwidth, isOpen, onClose }) {
   return (
      <div>
         <UiModal
            open={isOpen}
            onClose={() => onClose("false")}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
            <StyledBox fullwidth={fullwidth}>{children}</StyledBox>
         </UiModal>
      </div>
   )
}

const StyledBox = styled(Box)`
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   width: ${(props) => (props.fullwidth ? props.fullwidth : "425px")};
   background-color: white;
   border-radius: 8px;
   padding: 15px;
   outline: none;
`